export default {
    inject: ["PointStore"],
    computed: {
        isProfileLevelInit: function () {
            return this.PointStore.state.isInitial;
        },
        profilePoint: function () {
            return this.PointStore.state.point;
        },
        profileLevelInfo: function () {
            return this.PointStore.state.profileLevel;
        },

        isLevelSliver: function () {
            if (this.isProfileLevelInit) {
                let levelInfo = this.profileLevelInfo;
                let level = levelInfo.currentLevel;
                return level == 'Silver';
            }
            return false;
        },
        isLevelGold: function () {
            if (this.isProfileLevelInit) {
                let levelInfo = this.profileLevelInfo;
                let level = levelInfo.currentLevel;
                return level == 'Gold';
            }
            return false;
        },
        isLevelPlatinum: function () {
            if (this.isProfileLevelInit) {
                let levelInfo = this.profileLevelInfo;
                let level = levelInfo.currentLevel;
                return level == 'Platinum';
            }
            return false;
        },
        isLevelDiamond: function () {
            if (this.isProfileLevelInit) {
                let levelInfo = this.profileLevelInfo;
                let level = levelInfo.currentLevel;
                return level == 'Diamond';
            }
            return false;
        },

        textClassColorLevel: function () {
            if (this.isLevelSliver) {
                return 'text-a-silver-9b9b9b';
            } else if (this.isLevelGold) {
                return 'text-a-yellow-e8af25';
            } else if (this.isLevelPlatinum) {
                return 'text-a-platinum-8f97b0';
            } else if (this.isLevelDiamond) {
                return 'text-a-red-d62300';
            }
            return '';
        },
        bgClassColorLevel: function () {
            if (this.isLevelSliver) {
                return 'bg-a-silver-9b9b9b';
            } else if (this.isLevelGold) {
                return 'bg-a-yellow-e8af25';
            } else if (this.isLevelPlatinum) {
                return 'bg-a-platinum-8f97b0';
            } else if (this.isLevelDiamond) {
                return 'bg-a-red-d62300';
            }
            return '';
        },
    },
    methods: {
        getProfileLevel: function () {
            return this.PointStore.methods.getProifleLevel();
        },
        getLevelDetail: function (profileLevel) {
            let levelName = profileLevel.currentLevel;
            let levelList = profileLevel.levelDetail;

            let levelDetail = levelList.find((item) => {
                return item.name_en == levelName;
            });

            return levelDetail;
        },
    },
}
